import { writable } from "svelte/store";

const initialState = { players: [], game: {} };

export const state = writable(initialState);

const initialSocketId = localStorage.getItem("socketId");

export const socketId = writable(initialSocketId);

socketId.subscribe((value) => {
    localStorage.setItem("socketId", value);
});
